import React, { useState } from 'react'
import { mdiPlus } from '@mdi/js'
import { useFormikContext } from 'formik'
import { createTableConfig } from '@components/Common/Table/scripts/tableConfig'
import { TableColumn, TableOption, TablePaginator, TableRow } from '@components/Common/Table'
import getEnderecoSearchCliente from '@modules/viagem/utils/getEnderecoSearchCliente'
import { tableViagemSearhClientColumns } from '@modules/viagem/constants/tableSearch'
import { searchClienteSistema as requestSearch, searchCliente } from '@modules/viagem/controllers/viagemController'
import { useAppDispatch, useAppSelector } from '@redux/hooks'
import { formatDocumento } from '@utils/format'
import { ModalSearchClienteProps } from '@modules/viagem/interfaces/SearchClienteModal'
import FormSearchCliente from '@modules/viagem/components/Search/FormSearchCliente'

const TableFilial: React.FC<ModalSearchClienteProps> = ({ setOpen, type }) => {

    const dispatch = useAppDispatch()
    const { searchClienteSistema } = useAppSelector(s => s.viagem)
    const { requestSearchFilial, requestSearchCliente } = useAppSelector(s => s.requestViagem)

    const [tableConfig] = useState(createTableConfig(
        'searchFilial',
        tableViagemSearhClientColumns
    ))

    const { setFieldValue } = useFormikContext()

    return (

        <>
            <TablePaginator
                data={searchClienteSistema}
                loading={requestSearchFilial.loading || requestSearchCliente.loading}
                config={tableConfig}
                options={
                    <>
                        <div />
                        <FormSearchCliente
                            type={type}
                            handleSearchSistema={v => {
                                requestSearch(dispatch, v, setFieldValue, false)
                            }}
                            handleSearchDocumento={v => {
                                searchCliente(dispatch, v, setFieldValue, false, 'cliente')
                            }}
                        />
                    </>
                }
                renderItem={(item, index) => (
                    <TableRow key={index}>
                        <TableColumn>{item.nome}</TableColumn>
                        <TableColumn width={160}>{formatDocumento(item.nroDocumento)}</TableColumn>
                        <TableColumn>{getEnderecoSearchCliente(item)}</TableColumn>
                        <TableColumn>
                            <TableOption
                                icon={mdiPlus}
                                status="success"
                                onClick={() => {
                                    setFieldValue('documentoFilial', item.nroDocumento)
                                    setFieldValue('nomeFilial', item.nome)
                                    setFieldValue('cidadeFilial', item.cidade)
                                    setFieldValue('ufFilial', item.uf)

                                    setOpen(false)
                                }}
                            />
                        </TableColumn>
                    </TableRow>
                )}
            />
        </>

    )

}

export default TableFilial